export const getSymbolFromCurrency = (currency) => {
    switch (currency) {		
        case 'USD':				
            return '$';		
        case 'GBP':				
            return '£';		
        case 'EUR':				
            return '€';		
        case 'AUD':				
            return 'AU$'; 	
        case 'CAD':				
            return 'CA$';	
        default:
            return '';    	
    }
};

